export const AMAZON_URL = "https://www.amazon.it/dp/B0HLWSB1BP";

export const HEADER = {
  brand: "PARALISI COGNITIVA — SALVATORE RUSSOLILLO",
  cta: "Riprendi la scelta ->",
};

export const HERO = {
  tech: "[TEMPO DI REAZIONE MACCHINA: 900 ms | TEMPO DI COSCIENZA UMANA: 40 s]",
  title: "Quando è stata l'ultima volta che hai deciso qualcosa, per intero, da solo?",
  subtitle:
    "Non parlo di scegliere un film da un catalogo ordinato per te o di obbedire al navigatore su una strada che conosci a memoria. Parlo di una decisione che pesasse. Se la risposta ti arriva subito, queste pagine ti serviranno a difendere una cosa che possiedi. Se devi pensarci, ti serviranno a capire che cosa stai perdendo, e quanto silenziosamente.",
  scrollCue: "\"Scorri lentamente. Qui il tempo appartiene ancora a te.\"",
  log: "03:47:12 | isolamento di rete | conferma operatore: attesa",
  counterLabel: "TEMPO UMANO TRASCORSO",
};

export const SECTION2 = {
  title:
    "Tutti i libri ti spiegano cosa faranno le macchine. Questo parla di cosa resta di te mentre le lasci fare.",
  paragraphs: [
    "Ti hanno fatto credere che delegare fosse comodità. Invece era una resa.",
    "Il mercato editoriale è saturo di manuali che celebrano la velocità degli algoritmi o insegnano a usarli per produrre di più. \"Paralisi Cognitiva\" apre una questione opposta, che nessun manuale tecnico osa affrontare: che cosa accade a un essere umano quando perde il tempo, le informazioni e il potere per decidere, ma resta l'unico a dover firmare in fondo al modulo e a pagare quando le cose vanno male?",
    "Lungi dall'essere un libro contro la tecnologia, è il primo atto d'accusa contro la finzione della supervisione umana. Perché tra scegliere di affidarsi e ritrovarsi affidati passa l'intera distanza che separa un uomo libero da un timbro.",
  ],
};

export const QUADRI = [
  {
    numeral: "I",
    title: "Quadro I — La faglia del tempo",
    text: "Un impulso nervoso corre a cento metri al secondo; la luce in una fibra ottica viaggia a duecentomila chilometri al secondo. Corrono sei ordini di grandezza: la distanza tra un passo e il cammino da Roma a Copenaghen. Mentre la nostra coscienza si accorge del problema, il sistema ha già isolato, deciso e archiviato. Il sistema scrive al passato prossimo, l'uomo legge al presente.",
  },
  {
    numeral: "II",
    title: "Quadro II — La zona di deformazione morale",
    text: "Nelle automobili, la zona di deformazione è la parte della carrozzeria progettata per accartocciarsi nell'urto e salvare i passeggeri. Nei sistemi automatici quella carrozzeria siamo noi: l'analista di notte, il medico, il funzionario, il cittadino. Messi lì non per governare la macchina, ma per assorbire la colpa giuridica e morale di un fallimento che non avevamo il potere di impedire.",
  },
  {
    numeral: "III",
    title: "Quadro III — La fatica che il riposo non scioglie",
    text: "Chi è esaurito dal troppo lavoro si riprende dormendo. Chi sente di aver smesso di contare, col riposo peggiora, perché fermarsi gli conferma che tutto procede anche senza di lui. Portare la responsabilità piena avendo un potere nullo scava nella psiche una ferita morale silenziosa. Continuiamo a scegliere lo stesso numero di volte, solo che qualcun altro ha già apparecchiato il tavolo.",
  },
];

export const SECTION4 = {
  title: "Tre facoltà che nessuna macchina possiede, e che muoiono senza fare rumore.",
  intro:
    "Quando smettiamo di decidere per rifugiarci nel sollievo di una risposta già pronta, disattiviamo tre muscoli interiori:",
  faculties: [
    {
      id: "empatia",
      name: "L'Empatia:",
      text: "l'unica forza capace di guardare un'eccezione e vederci il volto di una persona anziché un rumore statistico da tollerare.",
    },
    {
      id: "intuizione",
      name: "L'Intuizione:",
      text: "una vita di esperienza ed errori compressa nel corpo, quella voce che dice \"qualcosa non mi torna\" prima ancora di saperlo spiegare.",
    },
    {
      id: "creativita",
      name: "La Creatività:",
      text: "il potere di inventare l'ottava opzione quando il menu a tendina sullo schermo ne prevede soltanto sette.",
    },
  ],
};

export const SECTION5 = {
  quote:
    "\"Il merito di questo libro è rendere concreta la domanda. Ci invita a guardare oltre la rassicurante presenza di un essere umano nel processo e a chiederci se quella persona abbia davvero il tempo di valutare, la possibilità di dissentire e l'autorità di cambiare l'esito. È una speranza esigente, perché chi progetta e governa questi sistemi deve assumersi la responsabilità delle proprie scelte.\"",
  quoteAuthor: "— Prof. Luigi Carrino, dalla Prefazione a Paralisi Cognitiva",
  authorName: "Salvatore Russolillo",
  authorBio:
    "Cyber Security Specialist, da oltre 13 anni progetta difese digitali e governa l'IA. Ha abitato in prima persona le sale di controllo e i processi decisionali critici che descrive in queste pagine, portando la riflessione di \"Paralisi Cognitiva\" fino al Premio Eccellenze Italiane a Washington D.C.",
};

export const WINDOW = {
  title: "Esperimento mentale · Cap. 3: La finestra dei 30 secondi",
  lines: [
    "> ALLARME CRITICO: Rilevata anomalia sul segmento di produzione (include i sistemi di refertazione ospedaliera).",
    "> AZIONE PROPOSTA: Isolamento immediato di rete.",
    "> Il silenzio dell'operatore allo scadere del timer varrà come approvazione formale a tuo nome.",
  ],
  confirm: "Conferma procedura",
  reject: "Rifiuta e scegli da solo",
  preselected: "[INVIO] preselezionato",
  ratified: (s) =>
    `REGISTRO AUDIT: procedura confermata in ${s} s. Hai ratificato senza decidere: sei diventato la zona di deformazione morale del sistema.`,
  timeout:
    "TEMPO SCADUTO — REGISTRO AUDIT: il tuo silenzio è stato registrato come consenso formale. Hai ratificato senza decidere. La tua firma è agli atti.",
  stillLocked: "> Accesso alla sezione finale: BLOCCATO. Il dissenso è ancora possibile.",
  rejected:
    "ATTRITO CRITICO ATTIVATO: Hai fermato l'automatismo e ti sei ripreso il diritto di capire. Questo è il punto da cui inizia Paralisi Cognitiva.",
  lockLabel: "SEZIONE FINALE",
  locked: "BLOCCATA",
  unlocked: "SBLOCCATA",
};

export const SECTION6 = {
  title: "L'atrofia non è un'amputazione.",
  paragraphs: [
    "Le neuroscienze hanno dimostrato che la passività è la risposta predefinita del nostro sistema nervoso davanti a ciò che non governiamo, mentre il controllo è un circuito cerebrale che vive solo se viene esercitato. Quel circuito, dentro di te, non è spento: è rimasto disoccupato. Riprende a lavorare nell'istante esatto in cui accetti di nuovo il peso di una scelta vera.",
    "Voltata la prima pagina di questo libro, non potrai più fingere di non vedere chi apparecchia il tavolo delle tue giornate.",
  ],
  manifesto:
    "\"Sbagliare per aver scelto è un modo di essere al mondo. Avere ragione per procura non lo è.\"",
  english: "Machines can calculate what is true, but only humans can decide what matters.",
  cta: "INTERROMPI L'AUTOMATISMO — ORDINA IL LIBRO SU AMAZON",
  subtext: "Disponibile su Amazon. Nessun algoritmo ha scelto per te se cliccare o meno.",
};

export const FOOTER = "www.paralisicognitiva.it — © Salvatore Russolillo. Tutti i diritti riservati.";

export const COVER = {
  title: "PARALISI COGNITIVA",
  author: "Salvatore Russolillo",
  subtitle: "Come abbiamo smesso di decidere, e come tornare a farlo",
};
